import { Dialog, DialogActions, makeStyles } from '@material-ui/core'
import React, { useEffect, useState } from 'react'

import { Button } from 'src/modules/ui'

const useStyles = makeStyles(theme => ({
  hubspotChat: {
    '& #hubspot-conversations-inline-iframe': {
      width: '100%',
      height: 500,
      border: 'none',
    },
  },
}))

const HubspotModal = ({ trigger }) => {
  const classes = useStyles()
  const [modalOpen, setModalOpen] = useState(false)
  const handleShowModal = () => setModalOpen(true)
  const handleCloseModal = () => setModalOpen(false)

  useEffect(() => {
    window.hsConversationsSettings = {
      inlineEmbedSelector: '#hubspot-chat',
      loadImmediately: true,
      disableAttachment: false,
    }

    // Load HubSpot script for Live Chat
    const script = document.createElement('script')
    script.src = '//js.hs-scripts.com/1907840.js'
    script.async = true
    script.id = 'hs-script-loader'

    document.body.appendChild(script)
  }, [])

  return (
    <>
      {trigger({ onClick: handleShowModal })}
      <Dialog
        open={true}
        style={{ display: modalOpen ? 'block' : 'none' }}
        fullWidth
      >
        <div id="hubspot-chat" className={classes.hubspotChat} />
        <DialogActions>
          <Button onClick={handleCloseModal}>Close</Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default HubspotModal
